<template>
  <div class="container step">
    <div class="group-container">
      <div class="group" v-for="(row,key) in dataRow" :key="key">
        <div class="content">
            {{row.title}}
        </div><!-- content end sub -->
        <div :class="'checkboxGroup' + ( row.half ? ' half' : '')">
          <div class="item" v-for="rows in row.checkbox" :key="rows.id">
            <input type="radio" @change="onChangeData(rows, row.keys)" :name="'s'+row.keys" :id="rows.id">
            <label :for="rows.id" class="text">
              <span class="checkboxText">{{rows.text}}</span>
              <textarea
              v-model="rows.remark"
              v-if="rows.text == '其他'" name="" placeholder="輸入文字"
              class="textarea" rows="4">
            </textarea>
            </label>
          </div>
        </div><!-- checkbox group end sub -->
      </div><!-- group end sub -->
    </div>
    <template>
      <router-link to="/step1" class="btn-prev el-icon-arrow-left"></router-link>
      <router-link to="/step1-2" class="btn-next el-icon-arrow-right"></router-link>
    </template>
  </div>
</template>

<script>
export default {
  name: 'step1-1',
  data () {
    return {
      pageChage: false,
      props: ['result'],
      selectData: {
        'step1-1': {
          id: '',
          text: '',
          remark: ''
        },
        'step1-2': {
          id: '',
          text: '',
          remark: ''
        }
      },
      dataRow: [
        {
          keys: 'step1-1',
          title: '目前在臨床上,CCR數值小於多少時,您會考慮停用Cisplatin治療?',
          half: true,
          checkbox: [
            {
              id: 's1-1',
              text: '<30ml/min',
              remark: ''
            },
            {
              id: 's1-2',
              text: '<40ml/min',
              remark: ''
            },
            {
              id: 's1-3',
              text: '<50ml/min',
              remark: ''
            },
            {
              id: 's1-4',
              text: '<60ml/min',
              remark: ''
            }
          ]
        },
        {
          keys: 'step1-2',
          title: '臨床上對於腎臟功能不好,不適用Cisplatin的mUC患者,您會採用如何的治療選擇?',
          half: false,
          checkbox: [
            {
              id: 's2-1',
              text: '改用Platinum類化療',
              remark: ''
            },
            {
              id: 's2-2',
              text: '改用免疫療法',
              remark: ''
            },
            {
              id: 's2-3',
              text: '其他',
              remark: ''
            }
          ]
        }
      ]
    }
  },
  methods: {
    onChangeData: function ($row, keys) {
      var val = this.selectData
      val[keys] = $row
      // console.log(this.selectData)
      if ((val['step1-1']['id'] !== '') && (val['step1-2']['id'] !== '')) {
        this.$emit('update:result', val)
        this.pageChage = true
      }
    }
  }
}
</script>

<style scoped>
  .container {text-align:center;}
  .container:before,
  .container:after {
    content:"";display:inline-block;
    vertical-align:middle;
    height:100%;width:0px;
  }
  a[class*="btn-"] {
    background:#aa89bd;color:white;
  }
</style>



// WEBPACK FOOTER //
// src/components/step1/question.vue